class RAMQResident {
    public Name: string;
    public Class: string;
    public PermitNumber: string;
}

export { RAMQResident };
